import {propertyTypes} from "@/services/properties";

const properties = {
  prodottoProperty: {
    code: "1a",
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  piuVersioniProperty: {
    code: "1b",
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatiProperty: {
    code: "1c",
    name: "Codice prodotti collegati",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: "2",
    extCode: "",
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: "3",
    name: "Mercato",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: "4",
    name: "Canale",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: "5",
    name: "Distributori",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaProdottoProperty: {
    code: "6",
    name: "Tipologia prodotto",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaSottostantiProperty: {
    code: "7",
    name: "Tipologia sottostanti",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: "8",
    name: "Prodotto in commercio",
    description: "",
    order: 10,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: "9a",
    name: "Inizio commercializzazione",
    description: "",
    order: 11,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: "9b",
    name: "Fine commercializzazione",
    description: "",
    order: 12,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: "10",
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 13,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaPremioProperty: {
    code: "11",
    name: "Tipologia premio",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataContrattoProperty: {
    code: "13",
    name: "Durata contrattuale",
    description: "",
    order: 15,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataPianoPagamentoPremiProperty: {
    code: "15",
    name: "Durata piano pagamento premi",
    description: "",
    order: 16,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMinPremioUnicoProperty: {
    code: "16",
    name: "Importo minimo del premio unico",
    description: "",
    order: 17,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMaxPremioUnicoProperty: {
    code: "17",
    name: "Importo massimo del premio unico",
    description: "",
    order: 18,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMinPremioRicAnnuoProperty: {
    code: "18",
    name: "Importo minimo del premio ricorrente (annuo)",
    description: "",
    order: 19,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  importoMaxPremioRicAnnuoProperty: {
    code: "19",
    name: "Importo massimo del premio ricorrente (annuo)",
    description: "",
    order: 20,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER  ,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  targetMarketProperty: {
    code: "20",
    name: "Target Market",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  orizzonteTemporaleSuggeritoProperty: {
    code: "21",
    name: "Orizzonte temporale suggerito",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  indicatoreSinteticoRischioProperty: {
    code: "22",
    name: "Indicatore sintetico di rischio",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiIngressoProperty: {
    code: "23",
    name: "Reduction in Yield - Costi di ingresso",
    description: "",
    order: 24,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiUscitaProperty: {
    code: "24",
    name: "Reduction in Yield - Costi di uscita",
    description: "",
    order: 25,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  reductionInYieldCostiCorrentiProperty: {
    code: "25",
    name: "Reduction in Yield - Costi correnti",
    description: "",
    order: 26,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Indicatori KID",
    sectionIndex: 3
  },
  assetAllocationProperty: {
    code: "26",
    name: "Asset Allocation",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMinGestioneSeparataProperty: {
    code: "27a",
    name: "Investimento minimo in Gestione Separata",
    description: "",
    order: 28,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMaxGestioneSeparataProperty: {
    code: "27b",
    name: "Investimento massimo in Gestione Separata",
    description: "",
    order: 29,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  gestioneSeparataProperty: {
    code: "28",
    name: "Gestione Separata",
    description: "",
    order: 30,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  ultimoRendCertGestioneSeparataProperty: {
    code: "29a",
    name: "Ultimo rendimento certificato Gestione Separata",
    description: "",
    order: 31,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  annoRendCertGestioneSeparataProperty: {
    code: "29b",
    name: "Anno rendimento certificato Gestione Separata",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  rendMinGarantitoProperty: {
    code: "30",
    name: "Rendimento minimo garantito",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  rendMinGarantitoMisuraProperty: {
    code: "31",
    name: "Rendimento minimo garantito - Misura",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty: {
    code: "32",
    name: "Presenza consolidamento annuo delle rivalutazioni contrattuali",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  consolidamentoAnnuoRivalutazioniContrattualiProperty: {
    code: "33",
    name: "Consolidamento annuo delle rivalutazioni contrattuali",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  fondoUtiliProperty: {
    code: "34",
    name: "Fondo Utili",
    description: "",
    order: 37,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMinRamoIIIProperty: {
    code: "35a",
    name: "Investimento minimo in Ramo III",
    description: "",
    order: 38,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  invMaxRamoIIIProperty: {
    code: "35b",
    name: "Investimento massimo in Ramo III",
    description: "",
    order: 39,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  numFondiInterniProperty: {
    code: "36",
    name: "Numero Fondi Interni",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  tipologiaFondiInterniProperty: {
    code: "37",
    name: "Tipologia Fondi Interni",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  numOICRETFProperty: {
    code: "38",
    name: "Numero OICR/ETF",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  presenzaProtezioneCapitaleProperty: {
    code: "39",
    name: "Presenza protezione del capitale",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  protezioneCapitaleProperty: {
    code: "40",
    name: "Protezione del capitale",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Investimento",
    sectionIndex: 4
  },
  opzioniContrattualiTipologiaProperty: {
    code: "45",
    name: "Opzioni contrattuali - Tipologia",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  cedolaProperty: {
    code: "46",
    name: "Cedola",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  decumuloProperty: {
    code: "47",
    name: "Decumulo",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  renditaProperty: {
    code: "48",
    name: "Rendita",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  stopLossProperty: {
    code: "49",
    name: "Stop Loss",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  takeProfitProperty: {
    code: "50",
    name: "Take Profit",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  progressiveInvestmentProperty: {
    code: "51",
    name: "Progressive Investment",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  automaticRebalanceProperty: {
    code: "52",
    name: "Automatic Rebalance",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  downtrendOpportunityProperty: {
    code: "53",
    name: "Downtrend Opportunity",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  lifeCycleProperty: {
    code: "54",
    name: "Life Cycle",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  altreOpzioniContrattualiProperty: {
    code: "55",
    name: "Altre opzioni contrattuali",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Opzioni contrattuali",
    sectionIndex: 5
  },
  garanzieAssicurativeTipologiaProperty: {
    code: "62",
    name: "Garanzie assicurative - Tipologia",
    description: "",
    order: 56,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMorteStandardProperty: {
    code: "63",
    name: "Maggiorazione caso morte standard",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMorteStandardPrestazioneProperty: {
    code: "64",
    name: "Maggiorazione caso morte standard - Prestazione",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [
      { 
        value: "",
        showSign: true, 
        valueSign: "",
        valueSignReadonly: false,
        valueSignLeft: false,
        showLabel: false,
        valueLabel: "",
        valueLabelReadonly:false,
        valueLabelFix: false
      }
    ],
    type: propertyTypes.STRING_LIST,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerInfortunioProperty: {
    code: "65",
    name: "Maggiorazione caso morte per infortunio",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerInfortunioPrestazioneProperty: {
    code: "66",
    name: "Maggiorazione caso morte per infortunio - Prestazione",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerIncidenteStradaleProperty: {
    code: "67",
    name: "Maggiorazione caso morte per incidente stradale",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty: {
    code: "68",
    name: "Maggiorazione caso morte per incidente stradale - Prestazione",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerMinusvalenzaProperty: {
    code: "69",
    name: "Maggiorazione caso morte per minusvalenza",
    description: "",
    order: 63,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty: {
    code: "70",
    name: "Maggiorazione caso morte per minusvalenza - Prestazione",
    description: "",
    order: 64,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  TCMStandAloneProperty: {
    code: "71",
    name: "TCM stand alone",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  TCMStandAlonePrestazioneProperty: {
    code: "72",
    name: "TCM stand alone - Prestazione",
    description: "",
    order: 66,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  longTermCareProperty: {
    code: "73",
    name: "Long Term Care",
    description: "",
    order: 67,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  longTermCarePrestazioneProperty: {
    code: "74",
    name: "Long Term Care - Prestazione",
    description: "",
    order: 68,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  dreadDiseaseProperty: {
    code: "75",
    name: "Dread Disease",
    description: "",
    order: 69,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  dreadDiseasePrestazioneProperty: {
    code: "76",
    name: "Dread Disease - Prestazione",
    description: "",
    order: 70,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  invaliditaInabilitaProperty: {
    code: "77",
    name: "Invalidità/Inabilità",
    description: "",
    order: 71,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  invaliditaInabilitaPrestazioneProperty: {
    code: "78",
    name: "Invalidità/Inabilità - Prestazione",
    description: "",
    order: 72,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  altreGaranzieAssicurativeProperty: {
    code: "80",
    name: "Altre garanzie assicurative",
    description: "",
    order: 73,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 6
  },
  tipologiaBonusIngressoProperty: {
    code: "81",
    name: "Tipologia bonus d'ingresso",
    description: "",
    order: 74,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  bonusIngressoProperty: {
    code: "82",
    name: "Bonus d'ingresso",
    description: "",
    order: 75,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        toValueOperator: "",
        showValue: true,
        value: "",
        valueSign: "",
        valueSignLeft: false,
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  tipologiaBonusFedeltaProperty: {
    code: "83",
    name: "Tipologia bonus fedeltà",
    description: "",
    order: 76,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  bonusFedeltaProperty: {
    code: "84",
    name: "Bonus fedeltà",
    description: "",
    order: 76,
    value: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Bonus",
    sectionIndex: 7
  },
  speseEmissioneProperty: {
    code: "85",
    name: "Spese di emissione",
    description: "",
    order: 77,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCaricamentoPICProperty: {
    code: "86",
    name: "Tipologia Caricamento PIC (%)",
    description: "",
    order: 78,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoPICProperty: {
    code: "87",
    name: "Caricamento PIC (%)",
    description: "",
    order: 79,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCaricamentoPACProperty: {
    code: "88",
    name: "Tipologia Caricamento PAC (%)",
    description: "",
    order: 80,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoPACProperty: {
    code: "89",
    name: "Caricamento PAC (%)",
    description: "",
    order: 81,
    value: "",
    values: [],
    valueSign: "",
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  caricamentoProperty: {
    code: "90",
    name: "Caricamento (€)",
    description: "",
    order: 82,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCommissioneGestioneSeparataProperty: {
    code: "91",
    name: "Tipologia commissione Gestione Separata",
    description: "",
    order: 83,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneGestioneSeparataProperty: {
    code: "92",
    name: "Commissione Gestione Separata",
    description: "",
    order: 84,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    stringList: [
      { 
        value: "",
        showSign: false, 
        valueSign: "",
        valueSignReadonly: false,
        valueSignLeft: false,
        showLabel: false,
        valueLabel: "",
        valueLabelReadonly: false,
        valueLabelFix: true
      }
    ],    
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaCommissioneFondiInterniProperty: {
    code: "93",
    name: "Tipologia commissione Fondi Interni",
    description: "",
    order: 85,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniAzionariProperty: {
    code: "94",
    name: "Commissione Fondi Interni Azionari",
    description: "",
    order: 86,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniObbligazionariProperty: {
    code: "95",
    name: "Commissione Fondi Interni Obbligazionari",
    description: "",
    order: 87,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniBilanciatiProperty: {
    code: "96",
    name: "Commissione Fondi Interni Bilanciati",
    description: "",
    order: 88,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniFlessibiliProperty: {
    code: "97",
    name: "Commissione Fondi Interni Flessibili",
    description: "",
    order: 89,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneFondiInterniMonetariProperty: {
    code: "98",
    name: "Commissione Fondi Interni Monetari",
    description: "",
    order: 90,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneSottostantiFondiInterniProperty: {
    code: "99",
    name: "Commissione sottostanti Fondi Interni",
    description: "",
    order: 91,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  tipologiaSpeseGestionePolizzaOICRETFProperty: {
    code: "100",
    name: "Tipologia spese gestione polizza (OICR/ETF)",
    description: "",
    order: 92,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFAzionariProperty: {
    code: "101",
    name: "Spese gestione polizza OICR/ETF Azionari",
    description: "",
    order: 93,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFObbligazionariProperty: {
    code: "102",
    name: "Spese gestione polizza OICR/ETF Obbligazionari",
    description: "",
    order: 94,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFBilanciatiProperty: {
    code: "103",
    name: "Spese gestione polizza OICR/ETF Bilanciati",
    description: "",
    order: 95,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFFlessibiliProperty: {
    code: "104",
    name: "Spese gestione polizza OICR/ETF Flessibili",
    description: "",
    order: 96,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  speseGestionePolizzaOICRETFMonetariProperty: {
    code: "105",
    name: "Spese gestione polizza OICR/ETF Monetari",
    description: "",
    order: 97,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    rangeValuesFlex: [
      {
        order: 0,
        label: "",
        from: "",
        fromSign: "",
        fromSignLeft: false,
        fromToOperator: "",
        to: "",
        toSign: "",
        toSignLeft: false,
        showValue: false,
        toValueOperator: "",
        value: "",
        valueSign: "",
        valueSignLeft: false,
        rangeValuesFlex: [
          {
            order: 0,
            label: "",
            from: "",
            fromSign: "",
            fromSignLeft: false,
            fromToOperator: "",
            to: "",
            toSign: "",
            toSignLeft: false,
            showValue: false,
            toValueOperator: "",
            value: "",
            valueSign: "",
            valueSignLeft: false,
          }
        ]
      }
    ],
    type: propertyTypes.RANGE_FLEX,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioneOICRETFProperty: {
    code: "106",
    name: "Commissione OICR/ETF",
    description: "",
    order: 98,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  applicazioneCommissioniOverperformanceProperty: {
    code: "107",
    name: "Applicazione commissioni di overperformance",
    description: "",
    order: 99,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioniOverperformanceProperty: {
    code: "108",
    name: "Commissioni di overperformance",
    description: "",
    order: 100,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  costoMaggiorazioneCasoMorteStandardProperty: {
    code: "109a",
    name: "Costo maggiorazione caso morte standard (%)",
    description: "",
    order: 101,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  riscattoProperty: {
    code: "109b",
    name: "Riscatto",
    description: "",
    order: 102,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  applicazioneCommissioniUscitaProperty: {
    code: "110",
    name: "Applicazione commissioni di uscita",
    description: "",
    order: 103,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  commissioniUscitaProperty: {
    code: "111",
    name: "Commissioni di uscita (%)",
    description: "",
    order: 104,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 8
  },
  altriCostiProperty: {
    code: "112",
    name: "Altri costi",
    description: "",
    order: 105,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 8
  },
  retrocessioneCaricamentoProperty: {
    code: "113",
    name: "Retrocessione Caricamento",
    description: "",
    order: 106,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  retrocessioneGestioneSeparataProperty: {
    code: "114",
    name: "Retrocessione Gestione Separata",
    description: "",
    order: 107,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  retrocessioneRamoIIIProperty: {
    code: "115",
    name: "Retrocessione Ramo III",
    description: "",
    order: 108,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 9
  },
  noteProperty: {
    code: "116",
    name: "Note",
    description: "",
    order: 109,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 10
  },
  codProdottoProperty: {
    code: "117",
    name: "Codice prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
};

export default properties;
